import { IViewSettings } from "./ViewSettings"

export const SHOW_CLOSED_REQUESTS_DEFAULT = false
export const SHOW_CANCELED_REQUESTS_DEFAULT = false

export interface IViewSettingsRequests {
    showClosedRequests?: boolean
    showCanceledRequests?: boolean
}

export default class ViewSettingsRequests implements IViewSettings {
    showClosedRequests: boolean = SHOW_CLOSED_REQUESTS_DEFAULT
    showCanceledRequests: boolean = SHOW_CANCELED_REQUESTS_DEFAULT

    constructor(data: IViewSettingsRequests) {
        if (typeof data.showClosedRequests !== "undefined") {
            this.showClosedRequests = data.showClosedRequests
        }
        if (typeof data.showCanceledRequests !== "undefined") {
            this.showCanceledRequests = data.showCanceledRequests
        }
    }

    get isDefault() {
        return this.showClosedRequests === SHOW_CLOSED_REQUESTS_DEFAULT && this.showCanceledRequests === SHOW_CANCELED_REQUESTS_DEFAULT
    }
}
